import { Marker } from "@react-google-maps/api";

interface MarkersProps {
  id: string;
  lat: number;
  lng: number;
  name: string;
  origin: boolean;
  label?: string | google.maps.MarkerLabel;
  color?: string;
}

function Markers({ id, lat, lng, name, origin, label, color }: MarkersProps) {
  const markerIcon = (color && typeof google !== 'undefined')
    ? {
        path: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z",
        fillColor: color,
        fillOpacity: 1,
        strokeColor: "#FFFFFF",
        strokeWeight: 3,
        scale: 2.5,
        anchor: new google.maps.Point(12, 22),
        labelOrigin: new google.maps.Point(12, 9),
      }
    : undefined;

  return (
    <>
      <Marker
        key={id}
        position={{
          lat: lat,
          lng: lng,
        }}
        title={name}
        icon={markerIcon}
        label={
          label
            ? {
                text: label as string,
                color: "white",
                fontSize: "24px",
                fontWeight: "700",
              }
            : undefined
        }
      />
    </>
  );
}

export default Markers;
